import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3.355 4.75h4.146v2.073H3.355V4.75zm0 4.146h7.953v2.063H3.355V8.896zm0 4.135h12.437v2.073H3.355v-2.073zm0 4.146h17.291v2.073H3.355v-2.073z"
}), 'SortAsc');